import React, {Component, ReactNode} from 'react'
import {createResidentPage, ResidentPagePropsSet} from '../shared/hoc/createResidentPage'
import PPStepper from '../shared/PPStepper'
import {HideInPC, HideInSP} from '../../styledComponents/ResponsiveConvenience'
import {HAVE_OR_NOT} from '../../CodeMaster'
import {ColumnFlexContainer} from '../../styledComponents/FlexComponents'
import styled from 'styled-components'
import {FontSize, FontWeights} from '../../styledComponents/Constants'
import {Box} from '@mui/material'
import {StyledSecondaryButton} from '../../styledComponents/Button'
import {
    unitOwnerConfirmationStepsForPc,
    unitOwnerConfirmationStepsForSp
} from './ResidentUnitOwnerConfirmationVerificationMethodSelectionPage'
import {Location} from 'react-router-dom'

export interface ResidentUnitOwnerConfirmationCompleteLocationState {
    unitOwnership: HAVE_OR_NOT
}

interface Props {
    location: Location<ResidentUnitOwnerConfirmationCompleteLocationState>
}

interface State {

}

class ResidentUnitOwnerConfirmationCompletePage extends Component<Props & ResidentPagePropsSet, State> {
    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
        if (!this.props.location.state?.unitOwnership) {
            throw Error('区分所有者の確認情報がありません。画面遷移が不正です。')
        }

        this.handleHomeButtonClick = this.handleHomeButtonClick.bind(this)
    }

    handleHomeButtonClick(): void {
        this.props.navigate(
            `/resident/mypage`,
        )
    }

    render(): ReactNode {
        const message: ReactNode = this.props.location.state.unitOwnership.value === HAVE_OR_NOT.HAVE.value
            ? <>
                <div>区分所有者であることを確認しました。</div>
                <div>総会メニューがご利用いただけます。</div>
            </>
            : <>
                <div>総会メニューは区分所有者のみご利用いただけます。</div>
                <div>区分所有者の確認は個人設定から変更ができます。</div>
            </>

        return <>
            <HideInSP>
                <PPStepper steps={unitOwnerConfirmationStepsForPc} activeStep={3}/>
            </HideInSP>
            <HideInPC>
                <PPStepper steps={unitOwnerConfirmationStepsForSp} activeStep={3} alternativeLabel/>
            </HideInPC>
            <ColumnFlexContainer>
                <Box height={'60px'}/>
                <img src={'/resources/images/icons/icon_reserve_complete.svg'} alt={'complete'}/>
                <Box height={'15px'}/>
                <MessageTitle>確認が完了しました</MessageTitle>
                <Box height={'15px'}/>
                <MessageDetail>{message}</MessageDetail>
                <Box height={'50px'}/>
                <StyledSecondaryButton onClick={this.handleHomeButtonClick}>
                    ホームへ戻る
                </StyledSecondaryButton>
                <Box height={'15px'}/>
            </ColumnFlexContainer>
        </>
    }
}

export default createResidentPage(ResidentUnitOwnerConfirmationCompletePage)

const MessageTitle = styled.div`
  font-size: ${FontSize.Big};
  font-weight: ${FontWeights.Bold};
`

const MessageDetail = styled.div`
  font-size: ${FontSize.Middle};
  text-align: center;
`
